<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label">{{$t("message.issueNumber") }}</label>
          <div class="col-sm-3">
            <div>
              <input
                type="number"
                :placeholder="$t('message.issueNumber')"
                v-model="issueNumber"
                name="issueNumber"
                class="form-control input"
                max="9999999999"
                min="0"
              />
            </div>
          </div>
          <label class="col-sm-2 control-label">{{$t("message.issueName") }}</label>
          <div class="col-sm-3">
            <div>
              <input
                type="text"
                :placeholder="$t('message.issueName')"
                v-model="title"
                name="search"
                class="form-control input"
                maxLength="30"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">
            {{$t("message.Status") }} 
          </label>
          <div class="col-sm-3">
            <div>
              <select class="form-control" v-model="status" name="status">
                <option  value="">{{$t("message.All") }}</option>
                <option value="0" class="ng-binding">{{$t("message.Draft") }} </option>
                <option value="10" class="ng-binding">{{$t("message.Published") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <button class="btn btn btn-primary" @click="search">{{$t("message.Search") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive">
              <div class="col-xs-12">{{rows.length}}{{$t("message.datagridresult") }}</div>
              <datatable :columns="columns" :data="rows">
                <template scope="{ row }">
                  <tr @dblclick="datataleCli(row)" :style="trStyle">
                    <td align="center">
                      <select-row :row="row"></select-row>
                    </td>
                    <td>
                      <span>{{row['title'+$i18n.locale]}}</span>
                    </td>
                    <td>
                      <span>{{row.issueNumber}}</span>
                    </td>
                    <td>
                      <span>{{row.status}}</span>
                    </td>
                    <td>
                      <span>{{row.createdTime}}</span>
                    </td>
                  </tr>
                </template>
              </datatable>
              <datatable-pager
                align="right"
                :style="navStaty"
                :per-page="per_page"
                type="short"
                v-model="page"
              ></datatable-pager>
            </div>
            <div class="col-sm-12" style="margin-top:-30px;">
              <div class="pull-right">
                <button
                  class="btn btn-white"
                  @click="gotoDetail"
                >{{$t("message.Add") }}</button>
                <button class="btn btn-white" v-if="$store.state.userInfo.systemUserRole.roleType==0" @click="showWarning">{{$t("message.Delete") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import selectall from "../components/common/selectAll";
import selectrow from "../components/common/selectRow";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  components: {
    "select-row": selectrow,
    "select-all": selectall
  },
  data() {
    return {
      page: 1,
      per_page: 20,
      filter: "",
      superLength: 0,
      superFalg: true,
      trStyle: {
        cursor: "pointer"
      },
      navStaty: {
        "margin-top": "-30px",
        "margin-bottom": "15px",
        "margin-right": "30px"
      },
      columns: [
      ],
      rows: [
        {
          title: "",
          issueNumber: "",
          status: "",
          createdTime: "",
        }
      ],
      selected_rows: [],
      title: "",
      issueNumber: "",
      status:"",
    };
  },
  created: function() {
    eventBus.$on(
      "selected",
      function(row) {
        if (this.selected_rows.indexOf(row) === -1) {
          this.selected_rows.push(row);
        }
      }.bind(this)
    );

    eventBus.$on(
      "deselected",
      function(row) {
        if (this.selected_rows.indexOf(row) !== -1) {
          let index = this.selected_rows.indexOf(row);
          this.selected_rows.splice(index, 1);
        }
      }.bind(this)
    );

    eventBus.$on(
      "select-all",
      function(selected) {
        Vue.set(this, "selected_rows", this.rows.slice(0));
      }.bind(this)
    );

    eventBus.$on(
      "deselect-all",
      function(selected) {
        Vue.set(this, "selected_rows", []);
      }.bind(this)
    );
  },
  methods: {
    formatDate(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return d + "/" + MM + "/" + y + " " + h + ":" + m + ":" + s;
    },
    publisherLength() {
      let userList = this.rows;
      let superLength = 0;
      for (var i = 0; i < userList.length; i++) {
        if (userList[i].roleId === "Publisher") {
          superLength++;
        }
      }
      this.superLength = superLength;
    },
    async init() {
      let objdata = this.getAuthObj;
      objdata.sortField = 'id';
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 10000;
      objdata.title = this.title;
      objdata.issueNumber = this.issueNumber;
      objdata.status = this.status;


      let data = await this.$store.dispatch("getMagazineList", this.setFormData(objdata));

      for(var i=0;i<data.data.resultList.length;i++){
        if (data.data.resultList[i].status == 0) {
          data.data.resultList[i].status = "draft";
        }else if (data.data.resultList[i].status == 10){
          data.data.resultList[i].status = "published";
        }else{
          data.data.resultList[i].status = data.data.resultList[i].status;
        }
        for(var j=0;j<data.data.resultList[i].langMap.length;j++){
          if(data.data.resultList[i].langMap[j].langCode=="en_US"){
            data.data.resultList[i]['title'+'en_US'] = data.data.resultList[i].langMap[j].title;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_HK"){
            data.data.resultList[i]['title'+'zh_HK'] = data.data.resultList[i].langMap[j].title;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_CN"){
            data.data.resultList[i]['title'+'zh_CN'] = data.data.resultList[i].langMap[j].title;
          }
        }
      }
      this.rows = data.data.resultList;
      this.publisherLength();
    },
    gotoDetail() {
      let userInfo = this.$store.state.userInfo;
      this.$router.push({ path: "/main/issueDetail" });
    },
    datataleCli(row) {
      this.$router.push({
        path: "/main/issueDetail",
        query: { id: row.id }
      });
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.init()
    },
    showWarning() {
      var that = this;
      if (this.selected_rows.length != 0) {
        // if (this.selected_rows.length == this.rows.length) {
        //   this.$store.commit("setwarning", {
        //     string: "Always keep at least 1 Publisher",
        //     boolean: true,
        //     button: [{
        //       name:this.$i18n.t("message.Cancel"),
        //       callBack:function(){}
        //     }]
        //   });
        // } else {
          this.$store.commit("setwarning", {
            string: this.$i18n.t("message.deleteContent"),
            boolean: true,
            button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.deleteList();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              }
            }]
          });
        // }
      }
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj;
      if (this.selected_rows.length != 0) {
        for (let i = 0; i < this.selected_rows.length; i++) {
          ids.push(this.selected_rows[i].id);
        }
      }
      objdata.magazineIds = ids;

      let data = await this.$store.dispatch("deleteMagazine", this.setFormData(objdata));
      if (data.data.errorCode === 0) {
        this.selected_rows=[]
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: []
        });
        this.init();
      }
    },
    cancel: function() {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    setColumns:function(){
      this.columns = [
        {
          label: "",
          align: "center",
          component: selectrow,
          headerComponent: selectall
        },
        { label: this.$i18n.t("message.issueName"), field: "title"+this.$i18n.locale },
        { label: this.$i18n.t("message.issueNumber"), field: "issueNumber" },
        { label: this.$i18n.t("message.Status"), field: "status" },
        { label: this.$i18n.t("message.createdTime"), field: "createdTime" },
      ]
    }
  },
  mounted() {
    this.setColumns();
    this.init();
  },
  computed:{
      _language(){
        return this.$store.state.userInfo.langCode
      }
  },
  watch: {
    selected_rows: function() {
      for (var row of this.rows) {
        if (this.selected_rows.indexOf(row) === -1) {
          return;
        }
      }
      eventBus.$emit("all-selected");
    },
    _language:function(){
      this.setColumns();
    }
  }
};
</script>

<style scoped>
.ui-grid-icon-ok:before {
  content: "\c362";
}
.ui-grid-icon:before,
.ui-grid-icon:before {
  font-family: "ui-grid";
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  margin-right: 0.2em;
  text-align: center;
  font-variant: normal;
  text-transform: none;
  line-height: 1em;
  margin-left: 0.2em;
}
</style>